import {
  apiRequest,
  masterWorkUnit,
  masterEmployeeStatus,
  exportExcel,
} from "../../../../../services/adapters/kepegawaian/dukService";

import {
  apiRequest as apiRequest2,
  getConfig,
} from "../../../../../services/adapters/kepegawaian/riwayatPangkatService";

class IndexRepository {
  fetchExportExcel = async (query) => {
    return await apiRequest(
      "get",
      exportExcel,
      {
        params: query,
      },
      true
    );
  };

  fetchWorkUnit = async (query) => {
    return await apiRequest(
      "get",
      masterWorkUnit,
      {
        params: query,
      },
      true
    );
  };

  fetchEmployeeStatus = async (query) => {
    return await apiRequest(
      "get",
      masterEmployeeStatus,
      {
        params: query,
      },
      true
    );
  };

  fetchConfig = async (query) => {
    return await apiRequest2(
      "get",
      getConfig,
      {
        params: query,
      },
      true
    );
  };
}

export default IndexRepository;
